module.exports = __webpack_public_path__ + "static/media/user.7e605209.svg";